import React from 'react';
import { PublishingPost } from '~/post/types.generated';
import { PostEntity } from '../../../../post/PostEntity';
import { usePostPermissions } from '../../../../post/hooks';

import { PostPreviewFooter } from '../Footer/styles';
import { EditDeleteActions } from './EditDeleteActions';
import { ShareAgainAction } from './ShareAgainAction';
import { CampaignActions } from './CampaignActions';

import { ButtonStyled } from './styles';

export const PostPreviewActions = ({
  post,
  setOpenModal,
}: {
  post: PublishingPost;
  setOpenModal: () => void;
}) => {
  const isSent = PostEntity.isSent(post);
  const { canEditPost } = usePostPermissions(post);
  const { serviceLink } = post;

  if (!canEditPost && !isSent) return null;

  return (
    <PostPreviewFooter alignContentToRight>
      {canEditPost && (
        <EditDeleteActions post={post} setOpenModal={setOpenModal} />
      )}
      {isSent && (
        <>
          {serviceLink && (
            <ButtonStyled
              type="text"
              size="small"
              label="View Post"
              onClick={() => {
                window.open(serviceLink, '_blank');
              }}
            />
          )}
          <CampaignActions post={post} />
          <ShareAgainAction post={post} setOpenModal={setOpenModal} />
        </>
      )}
    </PostPreviewFooter>
  );
};
